<template>
  <div class="activate-success">
    <!-- <div class="mp-nav">
      <span class="back-btn" @click="goHome">
        <van-icon name="arrow-left" />
      </span>
      <span class="nav-title">生效完成</span>
    </div> -->

    <div class="form-section">
      <!-- 成功标识 -->
      <div class="success-banner">
        <div class="check-circle">
          <van-icon name="success" size="52" color="#fff" />
        </div>
        <div class="success-title">设备已生效！</div>
        <div class="success-desc">店员激活成功，设备保障已生效</div>
      </div>

      <!-- 生效详情 -->
      <div class="detail-card">
        <div class="section-title">生效详情</div>
        <div class="detail-list">
          <div class="detail-row">
            <span class="label">设备名称</span>
            <span class="value">{{ deviceName }}</span>
          </div>
          <div class="detail-row">
            <span class="label">IMEI</span>
            <span class="value">{{ deviceInfo.imei || '--' }}</span>
          </div>
          <div class="detail-row">
            <span class="label">客户姓名</span>
            <span class="value">{{ deviceInfo.name || '--' }}</span>
          </div>
          <div class="detail-row">
            <span class="label">激活时间</span>
            <span class="value">{{ deviceInfo.exa_time || '--' }}</span>
          </div>
          <div class="detail-row">
            <span class="label">生效期</span>
            <span class="value valid-period">{{ validPeriod }}</span>
          </div>
          <div class="detail-row">
            <span class="label">绑定保险</span>
            <span class="value">{{ deviceInfo.card_name || '--' }}</span>
          </div>
          <!-- <div class="detail-row" v-if="deviceInfo.bare_price">
            <span class="label">指导价格</span>
            <span class="value">¥{{ deviceInfo.bare_price }}</span>
          </div> -->
        </div>
      </div>

      <my-button @click.native="goHome">返回首页</my-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivateSuccess',
  data() {
    return {
      deviceInfo: {},
    }
  },
  computed: {
    deviceName() {
      const { brand, model } = this.deviceInfo
      if (brand && model) return `${brand} ${model}`
      return brand || model || '--'
    },
    validPeriod() {
      const { term_time_start, term_time_end } = this.deviceInfo
      if (term_time_start && term_time_end) return `${term_time_start} 至 ${term_time_end}`
      return '--'
    },
  },
  mounted() {
    const deviceStr = sessionStorage.getItem('oppoDeviceInfo')
    if (deviceStr) {
      try { this.deviceInfo = JSON.parse(deviceStr) } catch (e) { /* noop */ }
    }
    const orderId = this.$route.query.order_id
    if (orderId) {
      this.$http.oppoDeviceDetail({ order_id: orderId })
        .then((res) => {
          if (res && res.data) {
            this.deviceInfo = res.data
          }
        })
        .catch(() => {})
    }
  },
  methods: {
    goHome() {
      sessionStorage.removeItem('oppoActivateForm')
      sessionStorage.removeItem('oppoDeviceInfo')
      this.$router.push({ path: '/Oppo/ClerkHome' })
    },
  },
}
</script>

<style lang="less" scoped>
.activate-success {
  min-height: 100vh;
  background: #f5f5f5;

  .mp-nav {
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    height: 88px;
    background: #fff;
    padding: 0 32px;
    border-bottom: 1px solid #f0f0f0;

    .back-btn {
      font-size: 36px;
      color: #333;
      margin-right: 20px;
      cursor: pointer;
    }

    .nav-title {
      font-size: 34px;
      font-weight: 600;
      color: #1a1a1a;
    }
  }

  .form-section {
    padding: 24px;

    .success-banner {
      background: #fff;
      border-radius: 16px;
      padding: 50px 30px 40px;
      text-align: center;
      margin-bottom: 20px;

      .check-circle {
        width: 100px;
        height: 100px;
        background: linear-gradient(135deg, #52c41a, #73d13d);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 24px;
        box-shadow: 0 8px 24px rgba(82, 196, 26, 0.3);
      }

      .success-title {
        font-size: 40px;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 12px;
      }

      .success-desc {
        font-size: 26px;
        color: #999;
      }
    }

    .detail-card {
      background: #fff;
      border-radius: 16px;
      padding: 30px 0 10px;
      margin-bottom: 20px;

      .section-title {
        font-size: 30px;
        font-weight: 600;
        color: #1a1a1a;
        padding: 0 30px 20px;
        border-bottom: 1px solid #f5f5f5;
        margin-bottom: 10px;
      }

      .detail-list {
        padding: 0 30px;

        .detail-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 0;
          border-bottom: 1px solid #f5f5f5;
          font-size: 28px;

          &:last-child {
            border-bottom: none;
          }

          .label {
            color: #999;
            flex-shrink: 0;
          }

          .value {
            color: #1a1a1a;
            font-weight: 500;
            text-align: right;
            max-width: 60%;
            word-break: break-all;
          }

          .valid-period {
            color: #52c41a;
            font-weight: 600;
          }

          .upgrade-tag {
            color: #1890ff;
          }

          .pay-amount {
            color: #ff4d4f;
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
